import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { PHONE_VALIDATION_REGEX } from '@/consts';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BILLING_PHONE_NAME = 'billing_phone';

interface Props {
  name?: string;
}

const InputBillingPhone: FC<Props> = ({ name = BILLING_PHONE_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (v) => {
          if (!v) return i18n.t('Uzupełnij numer telefonu');
          if (!PHONE_VALIDATION_REGEX.test(v))
            return i18n.t('Podaj prawidłowy numer telefonu');
          return true;
        },
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem className="col-span-3 sm:col-span-1">
          <FormControl>
            <Input
              label={i18n.t('Nr telefonu')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                const hasPlusPrefix = e.target.value
                  .trimStart()
                  .startsWith('+');
                const digits = e.target.value.replace(/\D/g, '');
                if (digits.length <= 13)
                  onChange(hasPlusPrefix ? `+${digits}` : digits);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputBillingPhone;
